// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"21cf6992","49":"bd80ded0","56":"f1657778","57":"7295e53f","166":"a825c9a5","229":"e3b29f80","338":"778332a5","404":"1c8c9565","498":"74114dab","626":"fc81fccd","717":"51f876eb","996":"6652979e"}[chunkId] + ".chunk.js";
};